{
	"card": {
		"annex_hint": "Confronta l'Allegato A firmato con quello generato dalla piattaforma: devono essere uguali, con la firma a mano.",
		"arrows": "Altre verifiche",
		"birth_date": "Nato il",
		"checked_by": "Controllato il {{date}}",
		"compliant": "Verifica conforme",
		"compliant_done": "Verifica conforme registrata.",
		"compliant_missing": "Prima spunta: {{items}}.",
		"course": "Corso",
		"credits": "CFU",
		"decided": "Esito registrato il {{date}}.",
		"declared": "Dichiarato",
		"document": "Documento",
		"documents": "Documenti della domanda",
		"download": "Scarica",
		"file_failed": "Non è stato possibile aprire il file. Riprova.",
		"for_item": "per {{item}}",
		"iseeu": "ISEEU",
		"ispeu": "ISPEU",
		"matched": "Coincide",
		"matches": "Coincide",
		"next": "Verifica successiva",
		"no_files": "La domanda non ha file.",
		"not_given": "Non indicato",
		"passport": "Passaporto",
		"pre_enrollment": "Preimmatricolazione",
		"previous": "Verifica precedente",
		"recorded_student_number": "Matricola registrata",
		"seat_lost": "Lo studente non ha più il posto: la verifica riprende solo se accetta una nuova offerta della struttura.",
		"student_number": "Matricola",
		"student_number_missing": "Manca il numero di matricola: chi era preimmatricolato lo deve dare prima della verifica conforme.",
		"tax_code": "Codice fiscale",
		"title": "Verifica · {{protocol}}",
		"undo": "Annulla",
		"year": "Anno"
	},
	"category": {
		"doctoral_and_specialization": "Dottorandi e specializzandi",
		"first_year": "Primo anno",
		"later_years": "Anni successivi"
	},
	"columns": {
		"name": "Studente"
	},
	"correction": {
		"action": "Correggi esito",
		"badge": "Corretta",
		"cause": "Causa",
		"cause_text": "Errore materiale di verifica",
		"confirm": "Correggi",
		"corrected": "Corretta da {{name}} il {{date}}.",
		"corrected_at": "Corretta il {{date}}.",
		"description": "Solo per un errore materiale di verifica, con la prova. L'esclusione si annulla, la verifica torna in attesa e lo studente torna in graduatoria nella sua posizione: riceve un'offerta solo se c'è un posto libero.",
		"done": "Esito corretto: la verifica è di nuovo in attesa.",
		"download": "Scarica la prova della correzione",
		"proof_hint": "Il documento che mostra l'errore della verifica.",
		"title": "Correggi l'esito della verifica"
	},
	"difference": {
		"action": "Valore diverso",
		"admission_gained": "Sarebbe ammesso anche alla quota {{quota}}.",
		"admission_lost": "Non sarebbe più ammesso alla quota {{quota}}.",
		"check": "Controlla",
		"close": "Chiudi",
		"description": "Scrivi il valore che si legge nel documento. La piattaforma rifà il calcolo della graduatoria con quel valore e ti dice se cambia qualcosa.",
		"has_effect": "Il valore documentato cambia l'esito: non è una differenza da annotare. Escludi con \"Non coincide\" e la causa del valore.",
		"in_favour": "Il valore documentato è a favore dello studente: non è una causa di esclusione e la graduatoria resta quella dei dati dichiarati. Annota la differenza: il controllo conta come fatto.",
		"line": "{{field}}: dichiarato {{declared}}, documentato {{documented}}",
		"no_effect": "Non cambia né l'ammissibilità né la posizione. Annota la differenza: il controllo conta come fatto.",
		"note": "Nota",
		"note_hint": "Facoltativa. Per esempio, da dove viene il valore.",
		"noted": "Differenza senza effetto",
		"position_changed": "La posizione nella sua categoria passa da {{from}} a {{to}}.",
		"position_lost": "Uscirebbe dalla graduatoria della sua categoria, dove è {{from}}°.",
		"position_new": "La posizione nella sua categoria diventa {{to}}.",
		"record": "Annota la differenza",
		"recorded": "Differenza annotata.",
		"title": "Valore diverso nel documento",
		"unchanged": "È lo stesso valore dichiarato: se il documento coincide, usa \"Coincide\"."
	},
	"exclusion": {
		"action": "Non coincide",
		"cause": "Causa",
		"confirm": "Escludi",
		"description": "Scegli la causa, allega la prova e conferma. L'offerta viene revocata, il posto passa al successivo e lo studente riceve un'email.",
		"documented": "Valore nel documento",
		"done": "Assegnatario escluso. Il posto passa al successivo.",
		"download": "Scarica la prova",
		"download_failed": "Non è stato possibile aprire la prova. Riprova.",
		"note": "Nota",
		"note_hint": "Facoltativa.",
		"proof_hint": "Il documento che non coincide con quanto dichiarato.",
		"recorded": "Registrata da {{name}} il {{date}}.",
		"recorded_at": "Registrata il {{date}}.",
		"summary": "Esclusione",
		"title": "Escludi l'assegnatario",
		"without_effect": "Il valore nel documento non cambia né l'ammissibilità né la posizione: annota la differenza con \"Valore diverso\"."
	},
	"item": {
		"credits": "CFU",
		"economic": "ISEEU e ISPEU",
		"enrollment": "Iscrizione e matricola",
		"identity": "Documento d'identità",
		"signed_annex": "Allegato A firmato"
	},
	"quota": {
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"state": {
		"compliant": "Conforme",
		"excluded": "Esclusa",
		"pending": "In attesa"
	},
	"student_number": {
		"confirm": "Registra",
		"date": "Arrivato il",
		"description": "Il numero che lo studente ha mandato in risposta alla richiesta. Allega il messaggio come prova, se c'è.",
		"done": "Numero di matricola registrato.",
		"number": "Numero di matricola",
		"proof_hint": "Facoltativa. Il messaggio con il numero: da un .eml si legge quando è arrivato.",
		"proposed": "Data e ora lette dal messaggio: controllale prima di registrare.",
		"reading": "Lettura del messaggio",
		"received": "Arrivato il {{date}}.",
		"record": "Registra numero di matricola",
		"request": "Chiedi numero di matricola",
		"request_again": "Chiedi di nuovo",
		"request_done": "Richiesta inviata allo studente.",
		"requested": "Chiesto il {{date}}.",
		"time": "Ora",
		"title": "Registra il numero di matricola"
	},
	"to_check": {
		"student_number": "Numero di matricola"
	}
}
